// src/utils/deviceId.js

/**
 * Generate a stable device fingerprint
 * (NO hardware access, browser-safe)
 */
function generateFingerprint() {
  const navigatorData = window.navigator;

  const fingerprintData = {
    userAgent: navigatorData.userAgent,
    platform: navigatorData.platform,
    language: navigatorData.language,
    languages: navigatorData.languages?.join(","),
    screen: `${window.screen.width}x${window.screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  return btoa(JSON.stringify(fingerprintData));
}

/**
 * Generate a random UUID (fallback)
 */
function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Get or create a deviceId
 * This value MUST remain stable on same device
 */
export function getDeviceId() {
  try {
    let deviceId = localStorage.getItem("DEVICE_ID");

    if (!deviceId) {
      const fingerprint = generateFingerprint();
      const uuid = generateUUID();

      // Combine fingerprint + uuid for strong uniqueness
      deviceId = `${fingerprint}.${uuid}`;

      localStorage.setItem("DEVICE_ID", deviceId);
    }

    return deviceId;
  } catch (err) {
    console.error("Device ID generation failed", err);
    return null;
  }
}
